/**
 * LERA Smart Selector — Bootstrap (Sprint 8.3C.3)
 * Loads architecture modules and exposes the public API.
 *
 * Dependencies (defer, in order):
 * - lera-smart-selector-core.js
 * - lera-smart-selector-bridge.js
 * - lera-smart-selector-controller.js
 * - lera-smart-selector-dropdown.js
 */
window.LeraSmartSelector = window.LeraSmartSelector || {};

(function (LSS) {
  LSS.version = '8.3C.3';

  LSS.init = function init(root) {
    return LSS.getInstance(root);
  };
})(window.LeraSmartSelector);
